import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('service-group?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('service-group/show/'+id);
    },    
    create(params) {
        return Service().post('service-group/create', params);
    },
    update(id, params) {
        return Service().post('service-group/update/'+id, params);
    },
    delete(id) {
        return Service().post('service-group/delete/'+id);
    }
}